<template>
  <div class="content">
    <loading name="lp" :active.sync="isLoading" :can-cancel="false" :is-full-page="true"></loading>
    <base-header class="pb-6">
      <div class="row align-items-center py-0">
      </div>
    </base-header>
    <div class="container-fluid mt--6">
      <div>
        <card class="no-border-card" body-classes="px-0 pb-1" footer-classes="pb-2">
          <template slot="header">
            <h3 class="mb-0">Users</h3>
            <p class="text-sm mb-0">The list of users (teachers and students).</p>
          </template>
          <div>
            <div class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
              <div>
                <base-button type="primary" @click.prevent="onNew" icon>
                <span class="btn-inner--icon">
                <i class="ni e-add"></i>
              </span>New user</base-button>
              </div>

              <el-select
                class="select-primary pagination-select"
                v-model="role"
                placeholder="Role"
                @change="onRoleChanged"
              >
                <el-option
                  class="select-primary"
                  v-for="(item,index) in roles"
                  :key="index"
                  :label="item"
                  :value="index + 1"
                ></el-option>
              </el-select>

              <el-select
                class="select-primary pagination-select"
                v-model="pagination.perPage"
                placeholder="Per page"
              >
                <el-option
                  class="select-primary"
                  v-for="item in pagination.perPageOptions"
                  :key="item"
                  :label="item"
                  :value="item"
                ></el-option>
              </el-select>

              <div>
                <base-input
                  v-model="searchQuery"
                  prepend-icon="fas fa-search"
                  placeholder="Search..."
                ></base-input>
              </div>
            </div>
            <el-table
              :data="queriedData"
              row-key="id"
              header-row-class-name="thead-light"
              @sort-change="sortChange"
            >
            
              <el-table-column label min-width="100px" prop="picture">
                <template v-slot="{row}">
                  <div class="media align-items-center">
                    <a href="#">
                      <img class="rounded-circle profile-picture-sm"
                        alt="Image placeholder"
                        :src="row.picture=== null ? nophoto : fileurl + row.picture"
                      />
                    </a>
                  </div>
                </template>
              </el-table-column>
              <el-table-column v-for="column in tableColumns" :key="column.label" v-bind="column"></el-table-column>
              <el-table-column min-width="180px" align="right" label="Actions">
                <div slot-scope="{$index, row}" class="d-flex">
                  <base-button
                    @click.native="handleEdit($index, row)"
                    class="edit"
                    type="warning"
                    size="sm"
                    icon
                  >
                    <i class="text-white ni n-edit"></i>
                  </base-button>
                  <base-button
                    @click.native="handleDelete($index, row)"
                    class="remove btn-link"
                    type="danger"
                    size="sm"
                    icon
                  >
                    <i class="text-white ni e-remove"></i>
                  </base-button>
                </div>
              </el-table-column>
            </el-table>
          </div>
          <div
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <div class>
              <p class="card-category">Showing {{ from + 1 }} to {{ to }} of {{ total }} entries</p>
            </div>
            <base-pagination
              class="pagination-no-border"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
            ></base-pagination>
          </div>
        </card>
      </div>
    </div>
  </div>
</template>
<script>
import { Table, TableColumn, Select, Option } from "element-ui";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import { BasePagination } from "@/components";
import userTableMixin from "./userTableMixin";
import swal from "sweetalert2";
import { nophoto, fileUrl } from "../../../services/helper";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  mixins: [userTableMixin],
  components: {
    BasePagination,
    RouteBreadCrumb,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    Loading
  },
  props: {
    filter: String
  },
  data() {
    return {
      propsToSearch: ["name", "email", "age"],
      roles: ["Manager", "Teacher", "Student"],
      role: 1,
      nophoto: nophoto,
      users: [],
      tableColumns: [
        {
          prop: "fullname",
          label: "full name",
          minWidth: 180,
          sortable: true
        },
        {
          prop: "phone",
          label: "phone",
          minWidth: 160,
          sortable: true
        },
        {
          prop: "email",
          label: "email",
          minWidth: 200,
          sortable: true
        },
        {
          prop: "age",
          label: "Age",
          minWidth: 100,
          sortable: true
        }
      ],
      tableData: [],
      selectedRows: [],
      isLoading: false,
      datafilter: this.filter
    };
  },
  computed: {
    fileurl() { return fileUrl } 
  },
  methods: {
    onNew() {
      this.$router
        .push({ path: "/profile/"  + this.currfilter, params: { id: "" } })
        .catch(e => {});
    },
    handleEdit(index, row) {
      this.$router.push({ path: "/profile/" + this.currfilter + "/" + row.id }).catch(e => {});
    },
    handleDelete(index, row) {
      swal.fire({
        title: "Are you sure?",
        text: `You won't be able to revert this!`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-success btn-fill",
        cancelButtonClass: "btn btn-danger btn-fill",
        confirmButtonText: "Yes, delete it!",
        buttonsStyling: false
      }).then(result => {
        if (result.value) {
          this.deleteRow(row);
        }
      });
    }
  }
};
</script>
<style>
.no-border-card .card-footer {
  border-top: 0;
}
.profile-picture-sm {
  width: 50px;
  height: 50px;
}
</style>
